<template>
  <a-card :bordered="false">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol">
      <a-form-model-item label="标题" prop="title">
        <a-input
          v-model="ruleForm.title"
          placeholder="请输入"
          :maxLength="30"
          style="max-width:400px;"/>
      </a-form-model-item>
      <a-form-model-item label="封面">
        <div class="upload-box">
          <a-upload
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="handleChange"
            :before-upload="beforeUploadFile"
          >
            <div class="selected-image" v-if="ruleForm.imageUrl">
              <img :src="ruleForm.imageUrl" alt="avatar"/>
              <div class="delete" @click.stop="removeImage">
                <a-icon type="delete"/>
              </div>
            </div>
            <div v-else>
              <a-icon type="plus"/>
              <br>上传
            </div>
          </a-upload>
          <span class="hint-text">温馨提示：图片建议上传尺寸为210px*150px，格式.jpg、.png、.jpeg</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="分类名称" prop="categoryId">
        <a-select v-model="ruleForm.categoryId" placeholder="请选择" style="max-width: 400px">
          <a-select-option v-for="(item,index) in categoryList" :key="index" :value="item.id">
            {{ item.contentName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="内容类型" prop="contentType">
        <a-checkbox-group v-model="ruleForm.contentType" @change="onCheckedType" style="white-space: nowrap;">
          <a-checkbox value="1">
            视频内容
          </a-checkbox>
          <a-checkbox value="2">
            图文内容
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <div v-if="isShowVideo">
        <a-form-model-item label="视频" prop="videoUrl">
          <a-upload
            name="file"
            accept=".mp4"
            :action="uploadFileUrl"
            :multiple="false"
            :file-list="videoFileList"
            :remove="handleRemove"
            @change="handleVideoChange"
            :before-upload="beforeUploadVideo"
          >
            <a-button>
              <a-icon type="upload"/>
              上传
            </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="视频封面" prop="videoImageUrl">
          <div class="upload-box">
            <a-upload
              accept=".jpeg,.png,.jpg"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="handleVideoImageChange"
              :before-upload="beforeUploadFile"
            >
              <div class="selected-image" v-if="ruleForm.videoImageUrl">
                <img :src="ruleForm.videoImageUrl" alt="avatar"/>
              </div>
              <div v-else>
                <a-icon type="plus"/>
                <br>上传
              </div>
            </a-upload>
            <span class="hint-text">温馨提示：图片建议上传尺寸为690px*460px，格式.jpg、.png、.jpeg</span>
          </div>
        </a-form-model-item>
      </div>
      <div v-if="isShowRich">
        <a-form-model-item label="内容链接">
          <a-input
            v-model="ruleForm.contentUrl"
            placeholder="请输入"
            :maxLength="200"
            style="max-width:400px;"/>
        </a-form-model-item>
        <a-form-model-item label="内容详情">
          <div style="max-width:800px;">
            <vue-ueditor-wrap v-model="ruleForm.content" :config="myConfig" :destroy="true"></vue-ueditor-wrap>
          </div>
        </a-form-model-item>
      </div>
      <a-form-model-item label="作者" prop="author">
        <a-input
          v-model="ruleForm.author"
          placeholder="请输入"
          :maxLength="12"
          style="max-width:400px;"/>
      </a-form-model-item>
      <a-form-model-item label="内容时间" prop="publicTime">
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="dateValue"
          @change="onDateChange"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="onSubmit" :loading="submitLoading">提交</a-button>
        <a-button @click="backEvent" style="margin-left: 20px">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import VueUeditorWrap from 'vue-ueditor-wrap'
import moment from 'moment'

export default {
  name: 'AddContent',
  mixins: [ruleFormMixins],
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      moment,
      ruleForm: {
        title: '',
        content: '',
        imageUrl: '',
        contentUrl: '',
        videoUrl: '',
        publicTime: '',
        categoryId: '',
        author: '',
        contentType: [],
        videoImageUrl: ''
      },
      dateValue: undefined,
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        // content: [{ required: true, message: '请输入', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        author: [{ required: true, message: '请输入', trigger: 'blur' }],
        publicTime: [{ required: true, message: '请选择', trigger: 'blur' }],
        contentType: [{ required: true, message: '请选择内容类型', trigger: 'blur' }],
        videoUrl: [{ required: true, message: '请上传视频', trigger: 'blur' }],
        videoImageUrl: [{ required: true, message: '请上传视频封面', trigger: 'blur' }]
      },
      uploadFileUrl: this.getUploadFileUrl(),
      videoFileList: [],
      myConfig: {
        serverUrl: this.getFwbFileUrl(),
        UEDITOR_HOME_URL: '/UEditor/',
        autoHeightEnabled: false,
        autoFloatEnabled: false,
        initialFrameHeight: 340,
        initialFrameWidth: '100%',
        enableAutoSave: true
      },
      submitLoading: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      categoryList: [],
      id: '',
      requestId: '',
      isShowVideo: false,
      isShowRich: false
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ContentList', title: '内容列表' },
      { name: 'ContentCategory', title: '内容分类' },
      { name: 'Introduction', title: '景区介绍' },
      { name: 'ScenicAreaDynamic', title: '景区动态' }
    ])
    this.getCategoryList()
    this.requestId = Date.parse(new Date())
    this.id = this.$route.query.id
    if (this.id) {
      this.getDetails()
    }
  },
  methods: {
    onCheckedType(list) {
      this.changeType(list)
    },
    changeType(list) {
      let index1 = list.findIndex(item => {
        return item == 1
      })
      let index2 = list.findIndex(item => {
        return item == 2
      })
      if (index1 > -1) {
        this.isShowVideo = true
      } else {
        this.isShowVideo = false
        this.ruleForm.videoUrl = ''
        this.videoFileList = []
        this.ruleForm.videoImageUrl = ''
      }
      if (index2 > -1) {
        this.isShowRich = true
      } else {
        this.isShowRich = false
        this.ruleForm.content = ''
      }
      this.ruleForm.contentUrl = ''
    },
    removeImage() {
      this.ruleForm.imageUrl = ''
    },
    getDetails() {
      let url = '/advice/content/' + this.id
      this.getHttpServices().getServerApiService().post(url)
        .then(res => {
          this.ruleForm.title = res.title
          this.ruleForm.content = res.content
          this.ruleForm.imageUrl = res.imageUrl
          this.ruleForm.videoUrl = res.videoUrl
          this.ruleForm.publicTime = res.publicTime
          this.ruleForm.categoryId = res.categoryId
          this.ruleForm.author = res.author
          this.ruleForm.videoImageUrl = res.videoImageUrl
          this.ruleForm.contentType = res.contentType.split(',')
          this.changeType(this.ruleForm.contentType)
          this.ruleForm.contentUrl = res.contentUrl
          this.dateValue = res.publicTime ? moment(res.publicTime, 'YYYY-MM-DD') : undefined
          if (res.videoUrl) {
            this.videoFileList = [
              {
                uid: '-1',
                name: res.videoUrl,
                status: 'done',
                url: res.videoUrl
              }
            ]
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    backEvent() {
      this.$router.back(-1)
    },
    getCategoryList() {
      let url = '/advice/category/' + this.merchantId + '/' + this.platformId
      this.getHttpServices().getServerApiService().post(url)
        .then(list => {
          this.categoryList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getFwbFileUrl() {
      let appConfig = this.getAppConfig()
      this.getLogUtils().logWithTag('getFwbFileUrl', appConfig)
      return appConfig.fwbUrl
    },
    onDateChange(date, dateString) {
      this.dateValue = date
      this.ruleForm.publicTime = dateString
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      let params = {
        ...this.ruleForm,
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: this.id,
        requestId: this.requestId
      }
      params.contentType = params.contentType.join(',')
      this.getHttpServices().getServerApiService().post('advice/content/save', params)
        .then(res => {
          this.$message.success('保存成功')
          this.backEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          setTimeout(() => {
            this.submitLoading = false
          }, 500)
        })
    },

    handleVideoChange(info) {
      let { fileList } = info
      fileList = fileList.slice(-1)
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.ruleForm.videoUrl = this.getLatestUrlFromFileList(info.fileList)
      }
      this.videoFileList = [...fileList] //重点重点
    },
    beforeUploadVideo(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传视频大小不能超过 10MB!')
        return false
      }
      return true
    },
    handleRemove(e) {
      this.videoFileList = []
      this.ruleForm.videoUrl = ''
    },
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.ruleForm.imageUrl = this.getLatestUrlFromFileList(info.fileList)
        this.loading = false
      }
    },
    handleVideoImageChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        this.ruleForm.videoImageUrl = this.getLatestUrlFromFileList(info.fileList)
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    }
  }
}
</script>

<style lang="less">
.selected-image {
  width: 210px;
  height: 150px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .delete {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.upload-box {
  display: flex;

  .ant-upload-picture-card-wrapper {
    width: auto;
  }

  .hint-text {
    padding-top: 75px;
  }
}
</style>